import { post } from "./BaseFunctions";
const LoginFunction = (data) => {
  return post("auth/login", data);
};

export { LoginFunction };
